/**
 * Contato que representa um grupo de WhatsApp, e não uma pessoa.
 *
 * Mesma régua de `ContactMergeAction#group_contact?`: o marcador
 * `is_whatsapp_group` (custom ou additional attributes) ou o identificador
 * `group:<jid>` / `<jid>@g.us` — ingestões antigas só têm um dos dois.
 */
const isTruthy = value => value === true || value === 'true';

export const isAceleresGroupContact = contact => {
  if (!contact) return false;
  // A store da ficha converte o contato para camelCase; a busca e o painel da
  // conversa entregam snake_case. As chaves internas dos atributos não mudam.
  const attributes = [
    contact.custom_attributes,
    contact.customAttributes,
    contact.additional_attributes,
    contact.additionalAttributes,
  ];
  if (
    attributes.some(
      attrs =>
        isTruthy(attrs?.is_whatsapp_group) || isTruthy(attrs?.isWhatsappGroup)
    )
  )
    return true;

  const identifier = String(contact.identifier || '').toLowerCase();
  return identifier.startsWith('group:') || identifier.endsWith('@g.us');
};
